import React, { Component } from "react";
import {
  ComposedChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

class CustomTooltip extends Component {
  render() {
    const { active, payload } = this.props;
    if (active && payload) {
      var p = payload[0].payload;
      return (
        <div className="custom-tooltip">
          <p
            className="custom-label"
            style={{ color: "#000000" }}
          >{`Date : ${p.date}`}</p>
          <p
            className="custom-label"
            style={{ color: "#278dc1" }}
          >{`Transactions : ${p.Transactions}`}</p>
        </div>
      );
    }

    return null;
  }
}

class TransactionsChart extends Component {
  constructor(props) {
    super(props);
    this.elem = null;
    this.state = {
      width: 1,
      height: 1,
    };
  }

  updateDimensions() {
    if (this.elem != null) {
      this.setState({
        width: this.elem.getBoundingClientRect().width,
        height: this.elem.getBoundingClientRect().height,
      });
    }
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  render() {
    return (
      <div
        style={{ width: "100%", height: "268px", overflow: "hidden" }}
        ref={(elem) => {
          this.elem = elem;
        }}
      >
        <ComposedChart
          width={this.state.width}
          height={this.state.height}
          data={this.props.data}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          isAnimationActive={false}
        >
          <XAxis
            isAnimationActive={false}
            dataKey="name"
            heigth={6}
            domain={["dataMin", "dataMax"]}
            tickCount={12}
            tickSize={10}
            tick={{ fontSize: "10px" }}
          />
          <YAxis
            isAnimationActive={false}
            label={<p>Transactions</p>}
            tick={{ fontSize: "10px" }}
            orientation="right"
            width={20}
            scale="log"
            domain={["auto", "auto"]}
            tickSize={0}
            tickFormatter={(item) => {
              if (Number(item) > 1000) {
                item = Number(item) / 1000 + "K";
              }
              return item;
            }}
          />
          <CartesianGrid vertical={false} isAnimationActive={false} />
          <Tooltip isAnimationActive={false} content={<CustomTooltip />} />
          <Line
            type="monotone"
            dataKey="Transactions"
            stroke="#7ed321"
            strokeWidth={2}
            dot={false}
            isAnimationActive={false}
          />
        </ComposedChart>
      </div>
    );
  }
}
export default TransactionsChart;



// WEBPACK FOOTER //
// ./src/components/Stats/Charts/TransactionChart.js